"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dukeOfEdinburghSchool = exports.dukeOfEdinburghOrganisationName = exports.dukeOfEdinburghNumber = exports.dukeOfEdinburghLeaderToSign = exports.dukeOfEdinburgh = exports.ambassadorConfig = exports.AmbassadorDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _radioConfig = require("../../fields/Radio/radioConfig");

var _textfieldConfig = require("../../fields/Textfield/textfieldConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _textfieldConfig.TextfieldDefinition;
});

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _radioConfig.RadioDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var dukeOfEdinburgh = {
  key: 'dukeOfEdinburgh',
  type: 'radio',
  title: 'Is this volunteering going towards your Duke of Edinburgh Award?',
  normalize: 'boolean',
  items: [{
    key: 'yes',
    label: 'Yes',
    value: 'true'
  }, {
    key: 'no',
    label: 'No',
    value: 'false'
  }],
  ui: {
    classes: 'large'
  },
  validation: [{
    required: true
  }]
};
exports.dukeOfEdinburgh = dukeOfEdinburgh;
var dukeOfEdinburghLeaderToSign = {
  key: 'dukeOfEdinburghLeaderToSign',
  type: 'radio',
  title: 'Do you have a Leader to sign off your volunteering hours?',
  normalize: 'boolean',
  items: [{
    key: 'yes',
    label: 'Yes',
    value: 'true'
  }, {
    key: 'no',
    label: 'No',
    value: 'false'
  }],
  ui: {
    classes: 'large'
  },
  validation: [{
    required: true
  }]
};
exports.dukeOfEdinburghLeaderToSign = dukeOfEdinburghLeaderToSign;
var dukeOfEdinburghNumber = {
  inputmode: 'numeric',
  key: 'dukeOfEdinburghNumber',
  maxLength: 100,
  normalize: 'number',
  pattern: '[0-9]*',
  label: 'What is your Duke of Edinburgh number?',
  type: 'text',
  validation: [{
    required: true
  }]
};
exports.dukeOfEdinburghNumber = dukeOfEdinburghNumber;
var dukeOfEdinburghSchool = {
  key: 'dukeOfEdinburghSchool',
  type: 'radio',
  title: 'Do your Duke of Edinburgh meetings take place at school?',
  normalize: 'boolean',
  items: [{
    key: 'yes',
    label: 'Yes',
    value: 'true'
  }, {
    key: 'no',
    label: 'No',
    value: 'false'
  }],
  ui: {
    classes: 'large'
  },
  validation: [{
    required: true
  }]
};
exports.dukeOfEdinburghSchool = dukeOfEdinburghSchool;
var dukeOfEdinburghOrganisationName = {
  key: 'dukeOfEdinburghOrganisationName',
  maxLength: 200,
  label: 'Please provide the name of the Organisation you attend',
  type: 'text',
  validation: []
};
exports.dukeOfEdinburghOrganisationName = dukeOfEdinburghOrganisationName;
var ambassadorConfig = {
  type: 'ambassador',
  fields: [dukeOfEdinburgh // @TODO: NOVA-7059: disabled to prevent backend validation blocking submission if fields are conditionally hidden in the frontend
  // dukeOfEdinburghLeaderToSign,
  // dukeOfEdinburghNumber,
  // dukeOfEdinburghSchool,
  // dukeOfEdinburghOrganisationName,
  ]
};
exports.ambassadorConfig = ambassadorConfig;

var AmbassadorDefinition = _flowRuntime["default"].type("AmbassadorDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("ambassador")))));

exports.AmbassadorDefinition = AmbassadorDefinition;